module.exports = __webpack_public_path__ + "static/img/04.2e35313.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/04.jpg
// module id = YenM
// module chunks = 0